<div id="location-list-wrapper">
  <span id="header">Location</span>
  <span id="search-wrapper"><input type="text" placeholder="Search..." id="search-for"
                                   (input)="onSearchTextChanged()" [(ngModel)]="searchText">
  <i class="fa fa-search"></i></span>
  <mat-list id="location-list">
    <app-loader *ngIf="showLoadingIndicator"></app-loader>
    <mat-checkbox [checked]="allSelected" [class.active]="allSelected" class="all-option"
                      [value]="DEFAULT_MEMBER_LOCATION.memberLocationName"
                      (click)="selectAllLocations($event)">{{DEFAULT_MEMBER_LOCATION.memberLocationName}}
    </mat-checkbox>
    <div id="location-options">
      <mat-checkbox *ngFor="let location of displayedLocations" [checked]="!allSelected && location.item.selected"
                        [class.active]="!allSelected && location.item.selected" [value]="location.item.displayText"
                        class="option" (click)="whenLocationClicked($event, location)">{{location.item.displayText}}
      </mat-checkbox>
    </div>
  </mat-list>
</div>
